<h4
  class="mb-4 p strong"
  [ngClass]="reverse ? 'text-white' : 'text-black' "
>
  <span>
    {{ text }}
  </span>
  <ng-container *ngIf="required">
    <app-required-asterisk></app-required-asterisk>
  </ng-container>
</h4>
